import { useEffect } from 'react';
import { simulationStatuses } from 'src/enums/simulations';
import { useProgressTimer } from './use-progress-timer';

export const useProgress = (
  status: string | undefined,
  updateIsRecalculating: (isRecalculating: boolean) => void,
  isRecalculating: boolean,
  isGeneratingEstimates: boolean,
): number => {
  const { progress, resetProgress, setProgress, startProgress, stopProgress } = useProgressTimer();

  useEffect(() => {
    if (!status && !isRecalculating && !isGeneratingEstimates) {
      resetProgress();
    } else if (isGeneratingEstimates) {
      startProgress(95);
    } else if (isRecalculating && !status) {
      startProgress(70);
    } else {
      switch (status) {
        case simulationStatuses.INITIALISING:
          startProgress(95);
          break;
        case simulationStatuses.PREPARING_RESULTS:
          stopProgress();
          setProgress(99);
          break;
        case simulationStatuses.FINISHED:
          stopProgress();
          updateIsRecalculating(false);
          setProgress(0);
          break;
        default:
          stopProgress();
          setProgress(0);
          break;
      }
    }

    return () => {
      stopProgress();
    };
  }, [
    status,
    isRecalculating,
    isGeneratingEstimates,
    resetProgress,
    setProgress,
    startProgress,
    stopProgress,
    updateIsRecalculating,
  ]);

  return progress;
};
